module.exports = __webpack_public_path__ + "static/media/payment-frequency.cfefa99f.svg";